import { FETCH_COUPONS_REQUEST, FETCH_COUPONS_SUCCESS, FETCH_COUPONS_FAILURE } from "../actions/couponsActions";

const initialState = {
  loading: false,
  coupons: [],
  error: null,
};

const couponsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUPONS_REQUEST:
      return {
        ...state,
        coupons: [],
        loading: true,
        error: null,
      };
    case FETCH_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: action.payload,
        error: null,
      };
    case FETCH_COUPONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default couponsReducer;


